/**
 * React, react redux and react localization imports
 */

import { useState } from 'react'

/**
 * Material imports
 */
import CloudOffIcon from '@mui/icons-material/CloudOff'
import HelpIcon from '@mui/icons-material/Help'
import WifiOffIcon from '@mui/icons-material/WifiOff'

/**
 * Relative exports to root directory
 */
import { Box, Modal, Paper } from '@mui/material'
import { useSelector } from 'react-redux'
import { sizing, useThemeMode } from '../../../theme'
import { TranslatableTypography } from './Typography'

export const Disconnected = () => {
  const { palette } = useThemeMode()
  const [open, setOpen] = useState(false)
  const { connectionError } = useSelector((state) => state?.error)

  const disconnectedStyle = {
    '&': {
      '&.visible': {
        visibility: 'visible'
      },
      '&.hidden': {
        visibility: 'hidden'
      },
      width: '100%',
      background: palette.headerBrightColor,
      textAlign: 'center',
      height: '32px',
      position: 'absolute',
      bottom: `${sizing.footer.height}px`,
      zIndex: 1000,
      '.companion-disconnected-label': {
        height: '32px',
        display: 'inline-block',
        color: palette.errorText,
        position: 'relative',
        '.MuiTypography-root': {
          fontWeight: 600,
          fontSize: '0.7rem',
          display: 'block',
          marginLeft: '10px',
          marginRight: '10px',
          lineHeight: '32px',
          height: '32px',
          float: 'left'
        },
        '.companion-help-icon': {
          lineHeight: '32px',
          height: '32px',
          display: 'block',
          float: 'left',
          color: palette.headerColor
        },
        '.companion-error-icon': {
          lineHeight: '32px',
          height: '32px',
          display: 'block',
          float: 'left'
        }
      }
    }
  }

  const disconnectedModalStyle = (palette) => ({
    '&': {
      padding: 20,
      '.companion-error-icon': {
        width: '128px',
        height: '128px',
        display: 'inline-block',
        color: palette.headerColor
      },
      '.MuiPaper-root': {
        marginLeft: 'calc(50% - 150px)',
        width: '300px',
        textAlign: 'center',
        padding: '10px',
        marginTop: '80px',
        filter: `drop-shadow(0px 0px 3px  ${palette.headerBrightColor})`,
        color: palette.textColor
      }
    }
  })

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const label = connectionError ? 'server-error' : 'consite-unavailable'
  const icon = connectionError ? <CloudOffIcon className="companion-error-icon" /> : <WifiOffIcon className="companion-error-icon" />
  const visibilityClass = connectionError ? ' ' : 'hidden'

  return (
    <Box sx={disconnectedStyle} className={visibilityClass}>
      <Modal open={open} onClose={handleClose} sx={disconnectedModalStyle(palette)}>
        <Paper>
          {icon}
          <TranslatableTypography>
            {`${label}-help`}
          </TranslatableTypography>
        </Paper>
      </Modal>
      <Box className="companion-disconnected-label" onClick={handleOpen}>
        {icon}
        <TranslatableTypography>{label}</TranslatableTypography>
        <HelpIcon className="companion-help-icon" />
      </Box>
    </Box>
  )
}

export const DisconnectedMenuItem = () => {
  const { palette } = useThemeMode()
  const { connectionError } = useSelector((state) => state?.error)
  const label = connectionError ? 'server-error' : 'consite-unavailable'
  const icon = connectionError ? <CloudOffIcon /> : <WifiOffIcon />

  const disconnectItemStyle = {
    '&': {
      fontSize: 14,
      color: palette.paperColor,
      textAlign: 'center',
      padding: '15px',
      '.MuiSvgIcon-root': {
        width: '64px',
        height: '64px',
        display: 'inline-block',
        color: palette.paperColor
      },
      '.MuiTypography-root': {
        marginTop: '15px'
      }
    }
  }

  return (
    <Box sx={disconnectItemStyle}>
      {icon}
      <TranslatableTypography>
        {`${label}-help`}
      </TranslatableTypography>
    </Box>
  )
}
